import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  member: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/member.vue").then(m => m.default || m))
}